export default __webpack_public_path__ + "static/media/collection-logo-2.e9923f9a.png";